module.exports = __webpack_public_path__ + "static/img/role-prefix.f155671b.svg";